export const SET_O5_REQUEST = 'SET_O5_REQUEST';
export const SET_O5_FAILED = 'SET_O5_FAILED';
export const SET_O5_OFFERING_REVENUES_SUCCESS = 'SET_O5_OFFERING_REVENUES_SUCCESS';
export const SET_O5_TIME_INTERVALS_SUCCESS = 'SET_O5_TIME_INTERVALS_SUCCESS';
export const CLEAN_O5 = 'CLEAN_O5';
